<template>
    <div class="left-side-modal-layout-container">
        <div class="title-container">
            <h1>{{ $t("global.modal.filters.title") }} :</h1>
        </div>
        <div class="content-container">
            <slot />
        </div>
        <div class="footer-container">
            <BasicButton :disabled="disabledApplyButton" @click="apply">
                {{ $t("global.modal.filters.applied") }}
            </BasicButton>
            <BasicButton
                :disabled="disabledDeleteAllButton"
                color="blue"
                @click="reset"
            >
                {{ $t("global.modal.filters.delete_all") }}
            </BasicButton>
        </div>
    </div>
</template>

<script>
import BasicButton from "@/components/basic/BasicButton.vue"

export default {
    name: "ModaleLayoutFilters",
    components: {
        BasicButton,
    },

    props: {
        disabledApplyButton: {
            type: Boolean,
            default: false,
        },
        disabledDeleteAllButton: {
            type: Boolean,
            default: false,
        },
    },

    inject: ["emitter"],

    methods: {
        apply() {
            this.$emit("apply")
            this.emitter.emit("close-modal")
        },

        reset() {
            this.$emit("reset")
            this.emitter.emit("close-modal")
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

h1,
p {
    margin: 0;
}

.left-side-modal-layout-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1em;

    .title-container {
        h1 {
            font-family: $font_avenir_heavy;
            font-size: $semiNormal;
        }
    }

    .content-container {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 1em;
    }

    .footer-container {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
    }
}
</style>
